import ToastMessages from "constants/ToastMessages";
import ErrorPage from "components/errors/ErrorPage";
import img404 from "images/illustration-404.svg";
import type { ReactNode } from "react";

interface NotFoundErrorPageProps {
  message?: string;
}

function NotFoundErrorPage({ message }: Readonly<NotFoundErrorPageProps>): ReactNode {
  return (
    <ErrorPage
      title="404"
      subtitle={ToastMessages.ERROR_NOT_FOUND}
      message={message}
      image={img404}
    />
  );
}

export default NotFoundErrorPage;
